import {intKeyedEntries, intKeys} from '@/helpers/javascript'

export function hubId ({ hostId, definitionName } : { hostId: number, definitionName: string }) {
	return hostId + ',' + definitionName
}

export function isOpened ({ id, hostId, definitionName } : { id?: number, hostId: number, definitionName: string }, opened: Record<string, boolean>) {
	return opened[id || hubId({ hostId, definitionName })]
}

export function neighbors(hostId: number, links: Record<number, Record<number, any[]>>): [number, any[]][] {
	return (links.hasOwnProperty(hostId) ? intKeyedEntries(links[hostId]) : []).concat(intKeys(links)
		.filter(id => links[id].hasOwnProperty(hostId)).map(id => [id, links[id][hostId]] as [number, any[]]))
}

export { default as fixHubsForce } from './fixHubsForce'
export { default as fixNodesForce } from './fixNodesForce'
export { default as ignoreHubsLinkForce } from './ignoreHubsLinkForce'
export { default as ignoreHubsManyBodyForce } from './ignoreHubsManyBodyForce'
export { default as ignoreHubsRadialForce } from './ignoreHubsRadialForce'
export { default as selectiveCollideForce } from './selectiveCollideForce'
export * from './viewport'
